// extracted by mini-css-extract-plugin
module.exports = {"w1flksht":"w1flksht","noMore":"noMore"};